import { createAction } from "@reduxjs/toolkit";
export const createIncome = createAction('createIncome');
export const deleteIncome = createAction('deleteIncome');
